
import React, { useEffect, useState } from 'react';
import { useSession } from '../context/SessionContext';
import { t } from '../services/sessionManager';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';

const Test: React.FC = () => {
  const { user, apiData, language, isAuthenticated, isLoading, refreshSession } = useSession();
  const navigate = useNavigate();
  const [spendingHeart, setSpendingHeart] = useState(false);
  const [spendingBrain, setSpendingBrain] = useState(false);

  useEffect(() => {
    // Client-side security check
    if (!isLoading && (!isAuthenticated || !user?.isAdmin)) {
      navigate(`/${language}`);
    }
  }, [isLoading, isAuthenticated, user, navigate, language]);

  const handleSpendHeart = async () => {
    setSpendingHeart(true);
    const Joisst = (window as any).Joisst;
    if (Joisst) {
      try {
        await Joisst.spendHearts(1);
        await refreshSession();
      } catch (err) {
        console.error(err);
      }
    }
    setSpendingHeart(false);
  };

  const handleSpendBrain = async () => {
    setSpendingBrain(true);
    const Joisst = (window as any).Joisst;
    if (Joisst) {
      try {
        await Joisst.spendBrains(1);
        await refreshSession();
      } catch (err) {
        console.error(err);
      }
    }
    setSpendingBrain(false);
  };

  if (!user?.isAdmin || !apiData) return null;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{t('testPage', language)}</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{t('currencyActions', language)}</h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-slate-800 rounded-xl">
              <span className="text-sm font-medium text-gray-600 dark:text-slate-300">{t('hearts', language)}: {apiData.hearts}</span>
              <Button 
                onClick={handleSpendHeart} 
                isLoading={spendingHeart}
                variant="danger"
                className="text-xs"
              >
                {t('spendHeart', language)}
              </Button>
            </div>
            
            <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-slate-800 rounded-xl">
              <span className="text-sm font-medium text-gray-600 dark:text-slate-300">{t('brains', language)}: {apiData.brains}</span>
              <Button 
                onClick={handleSpendBrain} 
                isLoading={spendingBrain}
                variant="accent"
                className="bg-purple-600 hover:bg-purple-700 text-xs"
              >
                {t('spendBrain', language)}
              </Button>
            </div>
          </div>
        </Card>

        <Card className="h-full">
           <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{t('referralDebug', language)}</h2>
           <div className="p-4 bg-gray-50 dark:bg-slate-800 rounded-xl text-sm font-mono break-all">
             <p className="text-gray-500 mb-2">Stored Session Referral:</p>
             <div className="text-primary dark:text-accent">
               {sessionStorage.getItem('joisst_referral') || '(None)'}
             </div>
           </div>
        </Card>
      </div>

      <Card>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{t('apiData', language)}</h2>
        <div className="bg-gray-900 text-gray-100 p-4 rounded-xl overflow-x-auto text-xs font-mono">
          <pre>{JSON.stringify(apiData, null, 2)}</pre>
        </div>
      </Card>
      
      <Card>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{t('localUserData', language)}</h2>
        <div className="bg-gray-900 text-gray-100 p-4 rounded-xl overflow-x-auto text-xs font-mono">
          <pre>{JSON.stringify(user, null, 2)}</pre>
        </div>
      </Card>
    </div>
  );
};

export default Test;
